<template>
  <div
    :class="[inlineAction ? 'oms-inline-message-action' : 'messagebtn', { 'popup-action-inline': inlineAction }]"
    @click.stop
    @mousedown.stop
    @mouseup.stop
  >
    <button
      v-if="inlineAction"
      type="button"
      class="oms-inline-message-btn"
      :disabled="processing || status == 10 || viewOnly == 'view'"
      aria-label="Send Message To Customer"
      title="Send Message To Customer"
      @click.stop="check()"
    >
      <v-icon small>sms</v-icon>
    </button>
    <v-btn
      v-else
      style="background: #ea7a1c !important"
      flat
      prepend-icon
      :disabled="processing || status == 10 || viewOnly == 'view'"
      color="white darken-1"
      @click.stop="check()"
      >Send Message To Customer</v-btn
    >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="40%"
      content-class="oms-job-dialog oms-job-dialog--message"
    >
      <v-spacer>
        <v-form ref="form" onSubmit="return false;">
          <v-card class="oms-job-popup-card oms-job-message-dialog-card">
            <v-card-title>
              <span class="headline">Send Message to Customer</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md12>
                    <p>Select Mode of Communication</p>
                    <v-checkbox
                      v-model="selected"
                      label="SMS"
                      value="sms"
                      class="message"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="selected"
                      label="Email"
                      value="email"
                      class="message"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex v-if="selected.indexOf('email') >= 0" xs12 sm6 md12>
                    <label class="send-message-label">Subject</label>
                    <v-text-field
                      v-model="subject"
                      placeholder="Enter subject"
                      class="pt-0 send-message-input"
                      outline
                      hide-details
                      single-line
                    />
                  </v-flex>
                  <v-flex md12>
                    <label class="send-message-label">Message</label>
                    <v-textarea
                      autocomplete="message"
                      placeholder="Type your message here"
                      v-model="message"
                      class="pt-0 send-message-input send-message-textarea"
                      outline
                      hide-details
                      rows="4"
                      no-resize
                    ></v-textarea>
                  </v-flex>

                  <small class="success" v-show="this.res">{{
                    this.res
                  }}</small>
                  <small class="error" v-show="this.x.error">{{
                    this.x.error
                  }}</small>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-text>
              <v-flex v-if="message">Message Preview:</v-flex>
              <v-flex
                v-if="message"
                xs12
                sm12
                md12
                class="break_long_text"
                style="word-break: break-all"
                >Dear {{ userName }},<br />
                Subject - {{ subject }} <br /><br />{{ message }}</v-flex
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="oms-btn oms-btn--secondary"
                flat
                @click="dialog = false"
                :disabled="processing"
              >
                Close
              </v-btn>
              <v-btn
                class="oms-dialog-action--primary oms-btn oms-btn--primary"
                @click="sendMessage"
                :disabled="processing"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-spacer>
      <!--            <ErrorBox :error="x.error" />-->
    </v-dialog>
  </div>
</template>
<script>
import { StorageKeys } from "../../constants/constants";
import ErrorBox from "@/components/Common/ErrorBox";
import { sendMessage } from "@/constants/api-urls.js";

export default {
  data() {
    return {
      res: "",
      opeartionName: "",
      dialog: false,
      selected: ["email"],
      subject: null,
      message: null,
      loading: false,
      processing: false,
      x: {
        error: "",
      },
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  components: {
    ErrorBox,
  },
  props: ["userId", "userName", "status", "viewOnly", "inlineAction"],
  methods: {
    async check() {
      this.processing=true;
      this.operationName = "send-message-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
          this.processing=false;
        this.dialog = true;
      } else {
          this.processing=false;
        return;
      }
    },
    sendMessage() {
      if (this.processing) {
        return;
      } else {
        this.processing = true;
        let type = "";
        if (this.selected.length === 2) {
          type = "both";
        } else if (this.selected.length === 1) {
          type = this.selected[0];
        } else if (!this.selected.length) {
          this.x.error = "Please select at least on mode.";
          setTimeout(() => (this.x.error = ""), 2000);
          this.processing = false;
          return false;
        }

        if (!this.subject) {
          this.x.error = "Please provide a suitable subject.";
          setTimeout(() => (this.x.error = ""), 2000);
          this.processing = false;
          return false;
        }

        if (!this.message) {
          this.x.error = "Please provide a message.";
          setTimeout(() => (this.x.error = ""), 2000);
          this.processing = false;
          return false;
        }
        this.dialog = true;
        let url = sendMessage;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          userId: this.userId.toString(),
          type: type,
          message: this.message,
        };
        if (type === "both" || type === "email") {
          body.subject = this.subject;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.processing = false;
            this.res = "Customer has been successfully communicated";
            this.selected = ["email"];
            this.message = "";
            this.subject = "";
            setTimeout(() => (this.res = ""), 3000);
          },
          (error) => {
            this.processing = false;
            this.dialog = true;
            this.x.error = "Unable to Send Message.";
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.m--t-10 {
  margin-top: 10px;
}
.message {
  display: inline-block;
  margin: 0 50px;
}
.communication {
  width: 40%;
}
.success {
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  color: #fff;
}
.error {
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  color: #fff;
}
.messagebtn {
  position: absolute;
  right: 20px;
  /* top: 25px;*/
}
.oms-inline-message-action.popup-action-inline {
  align-items: center;
  display: inline-flex !important;
  height: 30px;
  max-width: 30px;
  pointer-events: auto;
  position: relative !important;
  right: auto !important;
  width: 30px !important;
  z-index: 5;
}
.oms-inline-message-action.popup-action-inline .oms-inline-message-btn {
  align-items: center !important;
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 7px !important;
  box-shadow: none !important;
  color: #a85510 !important;
  cursor: pointer;
  display: inline-flex !important;
  height: 30px !important;
  justify-content: center !important;
  margin: 0 !important;
  min-height: 30px !important;
  min-width: 30px !important;
  padding: 0 !important;
  position: static !important;
  width: 30px !important;
}
.oms-inline-message-action.popup-action-inline .oms-inline-message-btn .v-icon {
  color: currentColor !important;
  font-size: 16px !important;
}
.oms-inline-message-action.popup-action-inline .oms-inline-message-btn:hover:not([disabled]) {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
  color: #8a420b !important;
}
.oms-inline-message-action.popup-action-inline .oms-inline-message-btn[disabled] {
  background: #f2f4f7 !important;
  border-color: #e4e7ec !important;
  color: #98a2b3 !important;
  cursor: default;
}
.oms-inline-message-action.popup-action-inline .v-btn {
  align-items: center !important;
  display: inline-flex !important;
  height: 30px !important;
  margin: 0 !important;
  min-height: 30px !important;
  pointer-events: auto;
  vertical-align: top;
}
.oms-inline-message-action.popup-action-inline .v-btn__content {
  align-items: center;
  display: inline-flex;
  height: 100%;
  line-height: 1;
  white-space: nowrap;
}
.oms-job-message-dialog-card {
  border-radius: 10px !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}
.oms-job-message-dialog-card .v-card__title {
  background: #fff7ed !important;
  border-bottom: 1px solid #fed7aa;
  min-height: 44px;
  padding: 10px 14px !important;
}
.oms-job-message-dialog-card .headline {
  color: #172033;
  font-size: 15px !important;
  font-weight: 900;
}
.oms-job-message-dialog-card .v-card__text {
  background: #ffffff;
  padding: 12px 16px !important;
}
.oms-job-message-dialog-card .v-card__actions {
  border-top: 1px solid #e4e7ec;
  padding: 10px 14px !important;
}
.oms-job-message-dialog-card .v-card__actions .v-btn {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: none;
}
.send-message-label {
  color: #3a382f;
  display: block;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.3;
  margin: 0 0 0.375rem;
}
.send-message-input {
  margin: 0 0 0.75rem !important;
  padding-top: 0 !important;
  width: 100%;
}
.send-message-input .v-label {
  display: none !important;
}
.send-message-input .v-input__slot::before,
.send-message-input .v-input__slot::after {
  display: none !important;
}
.send-message-input .v-input__slot,
.send-message-input.v-text-field--outline > .v-input__control > .v-input__slot {
  background: #ffffff !important;
  border: 0.0625rem solid #e4e1d9 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  min-height: 2.5rem !important;
  padding: 0.5rem 0.75rem !important;
}
.send-message-input.v-input--is-focused .v-input__slot {
  border-color: #ea7a1c !important;
  box-shadow: 0 0 0 0.1875rem rgba(234, 122, 28, 0.12) !important;
}
.send-message-textarea .v-input__slot {
  align-items: flex-start !important;
  min-height: 6.5rem !important;
}
.send-message-input input,
.send-message-input textarea {
  margin: 0 !important;
  padding: 0 !important;
}
.send-message-input input::placeholder,
.send-message-input textarea::placeholder {
  color: #8a857c !important;
  opacity: 1;
}
</style>
